import { Link, useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";
import { LogOut, Sparkles, Zap } from "lucide-react";

export const Navbar = () => {
  const { user, loading, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate("/");
  };

  return (
    <header className="sticky top-0 z-50 glass border-b border-border" data-testid="navbar">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2 font-display font-bold text-lg" data-testid="navbar-logo-link">
          <span className="w-8 h-8 rounded-lg bg-gradient-to-br from-[#8B5CF6] to-[#EC4899] flex items-center justify-center">
            <Sparkles className="w-4 h-4 text-white" />
          </span>
          Lumen<span className="text-gradient">AI</span>
        </Link>
        <nav className="flex items-center gap-2 sm:gap-4">
          <Link to="/tarifs" className="text-sm text-muted-foreground hover:text-foreground transition-colors hidden sm:block" data-testid="navbar-pricing-link">
            Tarifs
          </Link>
          {loading ? null : user ? (
            <>
              <span className="flex items-center gap-1 text-sm font-medium text-[#EC4899]" data-testid="navbar-credits-badge">
                <Zap className="w-3.5 h-3.5" /> {user.credits} crédits
              </span>
              <Link to="/mes-videos" className="text-sm text-muted-foreground hover:text-foreground transition-colors hidden sm:block" data-testid="navbar-videos-link">
                Mes vidéos
              </Link>
              <Button asChild size="sm" className="bg-gradient-to-r from-[#8B5CF6] to-[#EC4899] text-white border-0" data-testid="navbar-studio-button">
                <Link to="/studio">Studio</Link>
              </Button>
              <Button variant="ghost" size="icon" onClick={handleLogout} data-testid="navbar-logout-button" aria-label="Se déconnecter">
                <LogOut className="w-4 h-4" />
              </Button>
            </>
          ) : (
            <>
              <Button variant="ghost" size="sm" asChild data-testid="navbar-login-button">
                <Link to="/connexion">Connexion</Link>
              </Button>
              <Button size="sm" className="bg-gradient-to-r from-[#8B5CF6] to-[#EC4899] text-white border-0" asChild data-testid="navbar-signup-button">
                <Link to="/inscription">Commencer</Link>
              </Button>
            </>
          )}
        </nav>
      </div>
    </header>
  );
};

export default Navbar;
